// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yrtaaI22skkZ9u {
  margin-left: var(--ds-space-050, 4px);
}
.USTZeewLbe9kgN {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--ds-radius-full, 50%);
  background-color: var(--dynamic-button);
  color: var(--dynamic-text);
}
.USTZeewLbe9kgN.fUzsHST9vhC7EF {
  border-radius: var(--ds-radius-small, 3px);
}
.USTZeewLbe9kgN svg circle {
  stroke: var(--dynamic-icon);
}
.USTZeewLbe9kgN:hover {
  background-color: var(--dynamic-button-hovered);
  color: var(--dynamic-text);
}
.USTZeewLbe9kgN:hover svg circle {
  stroke: var(--dynamic-icon);
}
`, ""]);
// Exports
export var searchButton = `yrtaaI22skkZ9u`;
export var searchIcon = `USTZeewLbe9kgN`;
export var griffin = `fUzsHST9vhC7EF`;
export default ___CSS_LOADER_EXPORT___;
